import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { H1, P, APPLICATION_FINDER_URL, WIZARD_URL, } from 'shared';
import { setPrequalification } from '../actions';
import { ContactInfo } from '../components';
import OfferCard from '../components/OfferCard';
import { APPLICATION_STATUS_MESSAGES } from '../constants/applicationStatusMessages';
import { selectors } from '../reducer';
/*
  This page is shown when the user is hard declined by Bread.
  If the user has an Imprint offer, it is shown here and the
  user can select it and return to the Wizard.
*/
function DeclinedPage() {
    const history = useHistory();
    const dispatch = useDispatch();
    const prequalification = useSelector(selectors.prequalification);
    if (!prequalification) {
        history.push(APPLICATION_FINDER_URL);
        return null;
    }
    const offers = prequalification.offers ?? [];
    const ACCEPTABLE_IMPRINT_OFFER_TYPES = ['prequalified', 'step_up_pend'];
    const imprintOffer = offers.find((offer) => offer.serviceProviderName === 'Imprint' &&
        ACCEPTABLE_IMPRINT_OFFER_TYPES.includes(offer.offerType));
    const handleSelectOffer = () => {
        const updatedOffers = offers.filter((offer) => {
            return offer.serviceProviderName !== 'ADS';
        });
        dispatch(setPrequalification({ ...prequalification, offers: updatedOffers }));
        history.push({
            pathname: WIZARD_URL,
            state: {
                step: 'PRE-QUALIFICATION',
                fromFindMyApp: true,
            },
        });
    };
    return (_jsx("div", { className: "declined-container", children: imprintOffer ? (_jsxs(_Fragment, { children: [_jsx(H1, { variant: "title-extra-large", children: "We were unable to provide you with an Alphaeon Card. Please see below your Alphaeon Advantage offer." }), _jsx(DeclinedResponse, { withBoxShadow: true }), _jsx("div", { className: "w100", children: _jsx(OfferCard, { offer: imprintOffer, selectOfferCallback: handleSelectOffer }) })] })) : (_jsx(DeclinedResponse, {})) }));
}
const DeclinedResponse = ({ withBoxShadow = false, }) => {
    return (_jsxs("div", { className: classNames({
            'w100 pad-20 border-none': true,
            'box-shadow-glow': withBoxShadow,
        }), children: [_jsx(P, { children: APPLICATION_STATUS_MESSAGES.DECLINED.subtitle }), _jsx(P, { className: "mar-t-20", children: APPLICATION_STATUS_MESSAGES.DECLINED.message }), _jsx(ContactInfo, {})] }));
};
export default DeclinedPage;
